const CustomerList = {
  'pages_user_CustomerInfo.widthdraw': '계정 탈퇴',
  'pages_user_CustomerInfo.doWidthdraw': '탈퇴 하기',
  'pages_user_CustomerInfo.locale': '사용 언어',
  'pages_user_CustomerInfo.modify_receive': '수신 설정',
  'pages_user_CustomerInfo.receive_sms': 'SMS 수신 동의',
  'pages_user_CustomerInfo.company_name': '회사명',
  'pages_user_MyInfo.about_withdraw': '탈퇴 안내',
  'pages_user_MyInfo.1': '내 정보 관리',
  'pages_user_MyInfo.info.1': '내 정보',
  'pages_user_CustomerInfo.path.1': '사용자 관리',
  'pages_user_CustomerInfo.path.2': '사용자 정보 관리',
  'pages_user_CustomerInfo.company_info': '회사 정보',
  'pages_user_CustomerInfo.user-dropdown.deactive': '사용자 정지',
  'pages_user_CustomerInfo.user-dropdown.active': '사용자 활성',
  'pages_user_CustomerInfo.user-dropdown.remove': '사용자 삭제',
  'pages_user_CustomerInfo.1': '사용자 정보 관리',
  'pages_user_CustomerInfo.company.2': '도시',
  'pages_user_CustomerInfo.company.3': '주소',
  'pages_user_CustomerInfo.company.4': '자동이체 카드 정보',
  'pages_user_CustomerInfo.info.2': '부서명',
  'pages_user_CustomerInfo.info.3': '계정그룹',
  'pages_user_CustomerInfo.info.receive_sms': 'SMS 수신 동의',
  'pages_user_CustomerInfo.info.4': 'SNS1',
  'pages_user_CustomerInfo.info.5': 'SNS2',
  'pages_user_CustomerInfo.password.1': '최종변경일',
  'pages_user_CustomerInfo.card': '카드 미등록',
  'pages_user_CustomerInfo.card_registration': '카드 등록',
  'pages_user_CustomerInfo.change_status_Y': '사용자가 활성되었습니다.',
  'pages_user_CustomerInfo.change_status_N': '사용자가 정지되었습니다.',
  'pages_user_CustomerInfo.change_status_D': '사용자가 삭제되었습니다.',
  'pages_user_CustomerInfo.confirm_text': '정말로 계정을 삭제하시겠습니까?',
  'pages_user_CustomerInfo.lastlogin-info': '최종접속정보',
  'pages_user_CustomerInfo.lastlogin-time': '접속시간',
  'pages_user_CustomerInfo.lastlogin-device': '디바이스',
  'pages_user_CustomerInfo.lastlogin-ip': '아이피',
  'pages_user_CustomerInfo.security-setting': '보안 설정',
  'pages_user_CustomerInfo.disable-multi-login': '동시 로그인 제한',
  'pages_user_CustomerInfo.otp': '2단계 (MFA) 인증',
  'pages_user_CustomerInfo.otp-device-name': '디바이스명',
  'pages_user_CustomerInfo.has-force-logouted-title': '동일한 ID가  로그인됨',
  'pages_user_CustomerInfo.has-force-logouted-message-one': '동일한 ID가 다른 기기에 로그인되었습니다.',
  'pages_user_CustomerInfo.has-force-logouted-message-two': '다른 사용자가 로그인을 시도한 경우라면 암호를 재설정해주세요.',
  'pages_user_CustomerInfo.contract.delete.confirm': '해당 계약을 삭제 하시겠습니까?',
  'pages_user_CustomerInfo.contract.delete': '계약이 삭제 되었습니다.',
  'pages_user_CustomerInfo.contract.add': '계약이 추가 되었습니다.',
  'pages_user_CustomerInfo.otp-infomation': '다음 로그인 시 OTP 설정화면이 표시됩니다.',
  'pages_user_CustomerInfo.delete-otp-infomation': '디바이스를 삭제하시겠습니까?',
  'pages_user_CustomerInfo.has-deleted-otp': '디바이스를 삭제하였습니다.',
  'pages_user_CustomerInfo.withdraw-info.1': '탈퇴하시기 전에 다음 안내 사항을 반드시 확인해 주시기바랍니다.',
  'pages_user_CustomerInfo.withdraw-info.2': '* 사용하고 계신 계정은 탈퇴할 경우 재사용 및 복구가 불가능합니다.',
  'pages_user_CustomerInfo.withdraw-info.3': '* 탈퇴 후 회원정보 및 서비스 이용기록은 모두 삭제됩니다.',
  'pages_user_CustomerInfo.withdraw-info.4': '- 단, 상법, 전자상거래 등에서의 소비자 보호에 관한 법률 등 관계법령의 규정에 의하여 보존할 필요가 있는 경우 관계 법령에서 정한 일정한 기간',
  'pages_user_CustomerInfo.withdraw-info.5': '관련 정보를 보관합니다. 자세한 내용은 개인정보 처리방침을 참고하시기 바랍니다.',
  'pages_user_CustomerInfo.withdraw-info.6': '* OpsNow 계정을 사용하는 다른 서비스에 로그인할 수 없게 됩니다.',
  'pages_user_CustomerInfo.withdraw-info.7': '- OpsNow 계정을 사용하는 다른 서비스 목록',
  'pages_user_CustomerInfo.withdraw-info.do-agree': '안내 사항을 모두 확인하였으며, 이에 동의합니다.',


}

export default CustomerList



// WEBPACK FOOTER //
// ./src/lang/user/CustomerInfo.kr.js